import { api } from "@/lib/api";

/** Kun siffer. */
export const orgDigits = (value) => String(value || "").replace(/\D/g, "");

/** Norsk organisasjonsnummer: 9 siffer med MOD11-kontrollsiffer (vekter 3 2 7 6 5 4 3 2). */
export function isValidOrgNumber(value) {
  const d = orgDigits(value);
  if (d.length !== 9 || d[0] === "0") return false;
  const weights = [3, 2, 7, 6, 5, 4, 3, 2];
  const sum = weights.reduce((acc, w, i) => acc + Number(d[i]) * w, 0);
  const rest = sum % 11;
  const control = rest === 0 ? 0 : 11 - rest;
  return control !== 10 && control === Number(d[8]);
}

/** «923 609 016» */
export function formatOrgNumber(value) {
  const d = orgDigits(value);
  if (d.length !== 9) return String(value || "");
  return `${d.slice(0, 3)} ${d.slice(3, 6)} ${d.slice(6)}`;
}

export const brregUrl = (orgNumber) => `https://virksomhet.brreg.no/nb/oppslag/enheter/${orgDigits(orgNumber)}`;

/** Henter enhet (fallback underenhet) via backend-proxy (cache + throttling). Kaster axios-feil (400/404/503). */
export async function lookupOrg(orgNumber, { refresh = false } = {}) {
  const res = await api.get(`/brreg/enheter/${orgDigits(orgNumber)}`, { params: refresh ? { refresh: true } : undefined, timeout: 20000 });
  return res.data;
}

/** Navnesøk (eller org.nr) i Enhetsregisteret. */
export async function searchOrg(query, size = 8) {
  const res = await api.get("/brreg/sok", { params: { q: query, size }, timeout: 20000 });
  return res.data.items || [];
}

/** Mapper BRREG-enhet til skjemafelter vi bruker for kunder/leverandører/virksomheter. */
export function entityToFields(entity) {
  const a = entity?.address || entity?.business_address || entity?.postal_address || null;
  return {
    name: entity?.name || "",
    org_number: entity?.org_number || "",
    address: a?.address || "",
    postal_code: a?.postal_code || "",
    city: a?.city || "",
    country: a?.country || "Norge",
    website: entity?.website || "",
    entity_type: entity?.entity_type || null,
  };
}

/** Korte statusflagg til visning. */
export function entityFlags(entity) {
  const flags = [];
  if (!entity) return flags;
  if (entity.deleted_at) flags.push({ key: "slettet", label: `Slettet ${entity.deleted_at}`, tone: "danger" });
  if (entity.bankrupt) flags.push({ key: "konkurs", label: "Konkurs", tone: "danger" });
  if (entity.under_liquidation) flags.push({ key: "avvikling", label: "Under avvikling", tone: "warn" });
  if (entity.vat_registered === true) flags.push({ key: "mva", label: "MVA-registrert", tone: "ok" });
  else if (entity.vat_registered === false) flags.push({ key: "ikke-mva", label: "Ikke MVA-registrert", tone: "muted" });
  if (entity.source === "underenheter") flags.push({ key: "underenhet", label: "Underenhet", tone: "muted" });
  return flags;
}
